import { action, mutator } from 'satcheljs';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { setSelectedTab } from 'owa-mail-ribbon-store/lib/store/store';

export interface OnComposeRenderedActionMessage {
    viewState: ComposeViewState;
    isRendered: boolean;
    targetWindow: Window;
}
const onComposeRendered: (
    viewState: ComposeViewState,
    isRendered: boolean,
    targetWindow: Window
) => OnComposeRenderedActionMessage = action(
    'OnComposeRendered',
    (
        viewState: ComposeViewState,
        isRendered: boolean,
        targetWindow: Window
    ): OnComposeRenderedActionMessage => ({
        viewState,
        isRendered,
        targetWindow,
    })
);

mutator(onComposeRendered, ({ viewState, isRendered }) => {
    if (viewState.isComposeRendered != isRendered) {
        viewState.isComposeRendered = isRendered;
    }
});

mutator(onComposeRendered, ({ targetWindow }) => {
    setSelectedTab(10, targetWindow);
});

export default onComposeRendered;
